// Enum for notification types
export enum NotificationType {
  SUCCESS = "success",
  INFO = "info",
  ERROR = "error",
}

// Enum for notification icons
export enum NotificationIcon {
  SUCCESS = "FeatherCheckCircle",
  INFO = "FeatherCoins",
  ERROR = "FeatherAlertTriangle",
  MAIL = "FeatherMailCheck",
  CHECK2 = "FeatherCheckCircle2",
  CHECK = "FeatherCheck",
  ACTIVITY_SQUARE = "FeatherActivitySquare",
  ACTIVITY = "FeatherActivity",
  ALARM = "FeatherAlarmPlus",
}
